import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IError } from '@orgacard/login';

import { AppService } from '../../../app.service';
import { CoreService } from '../../../core/core.service';
import { EnvironmentService } from '../../../core/environment.service';
import { ImageService } from '../../../core/services/image.service';
import { UtilityHelperService } from '../../../core/utility-helper.service';
import { UtilityHelper } from '../../../core/utility.helper';
import { LoadingOverlayService } from '../../../loading-overlay/loading-overlay.service';
import { SearchbarType, StateEnum } from '../../shared/models/basic.model';
import { TitleBarFilter } from '../../shared/title-bar/models/FilterEnum';
import { SupplierService } from '../shared/services/supplier.service';

@Component({
    selector: 'oc-supplier-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],
    standalone: false,
})
export class OverviewComponent implements OnInit {
    private readonly utilityHelperService = inject(UtilityHelperService);
    private router = inject(Router);
    private environmentService = inject(EnvironmentService);
    supplierService = inject(SupplierService);
    private appService = inject(AppService);
    coreService = inject(CoreService);
    imageService = inject(ImageService);
    loadingOverlayService = inject(LoadingOverlayService);

    public utilityHelper = new UtilityHelper(this.appService, this.environmentService, this.coreService, this.loadingOverlayService);

    tempSearch: string = '';
    isRTL: boolean;
    viewMode = 'col';
    stateEnum = StateEnum;
    filterMessageTexts: string[] = [
        this.coreService.getMsgkey('mws.showall', undefined),
        this.coreService.getMsgkey('mws.showenabled', undefined),
        this.coreService.getMsgkey('mws.showcomplete', undefined),
        this.coreService.getMsgkey('mws.showincomplete', undefined),
        this.coreService.getMsgkey('mws.archived', undefined),
    ];
    showBlacklisted: boolean = false;
    titleBarFilter = TitleBarFilter;
    actualFilterType = TitleBarFilter.ENABLED;

    ngOnInit() {
        // this.getSupplierStates();
        // this.getSuppliers(TitleBarFilter.ENABLED, undefined);
        this.getSuppliersOverviewWithFilterAndSearchbox(TitleBarFilter.ENABLED, undefined);
    }

    private getSuppliers(filterType: TitleBarFilter, searchValue: string) {
        if (this.environmentService.currentUserCostcenterId) {
            this.loadingOverlayService.startLoading();
            this.supplierService.getSuppliersOverview(filterType, searchValue).subscribe(
                (data: any) => {
                    if (this.environmentService.appSettings.showLog)
                        console.log(new Date() + ': ' + 'overview.component.ts - getSuppliers ---> RESPONSE data: ' + data);
                    this.loadingOverlayService.stopLoading();
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
        } else {
            console.log('OC-ERROR -5788: supplier - overview.component getSuppliers() - currentUserCostcenterId undefined !');
        }
    }

    getSuppliersBlacklisted() {
        this.showBlacklisted = true;
        //
        this.getSuppliers(TitleBarFilter.ACTIVE, '');
    }

    getSuppliersOverviewWithFilterAndSearchbox(filterType: TitleBarFilter, searchValue: string) {
        this.showBlacklisted = false;
        this.actualFilterType = filterType;
        this.getSuppliers(filterType, searchValue);
    }

    // getSupplierStates() {
    //     this.supplierService.getSupplierStates().subscribe((data: any) => {
    //         if (this.environmentService.appSettings.showLog) console.log(new Date() + ': ' + 'overview.component.ts - getSupplierStates ---> RESPONSE data: ' + data);
    //     }, (err: IError) => {
    //         this.utilityHelperService.handleComponentError(err);
    //     });
    // }

    onSearchbarEvent(event: { value: string; searchType: SearchbarType }) {
        // console.log('onSearchbarEvent: ' + event.value);
        this.tempSearch = event.value;
        this.getSuppliers(this.actualFilterType, this.tempSearch);
    }

    selectSupplier(supplierId: number, costcenterId: number) {
        if (supplierId && costcenterId) {
            this.router.navigate(['/mwsp/supplier/detail/EDIT/' + supplierId + '/' + costcenterId]);
        } else {
            this.appService.showToast('error', '', 'SupplierID or CostcenterID not found');
        }
    }

    importData() {
        this.appService.showToast('info', 'Funktionalität', 'noch nicht implementiert');
    }
}
